import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55cb59c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "base-box df both-size menu-page",
  style: {"padding":"20px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing" }, null, -1))
const _hoisted_3 = { class: "box right" }
const _hoisted_4 = { class: "authority-management" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "authority-title df both-side vertical" }, [
  /*#__PURE__*/_createElementVNode("div", null, "菜单权限管理")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "authority-name" }, [
  /*#__PURE__*/_createElementVNode("text", null, "菜单"),
  /*#__PURE__*/_createElementVNode("text", { class: "authority-name-spacing" }, "权限")
], -1))
const _hoisted_7 = { class: "authority-button df directon-right vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_after_sale = _resolveComponent("after-sale")!
  const _component_tree_node = _resolveComponent("tree-node")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_filter_menu = _resolveComponent("filter-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_after_sale, {
        onSelectUser: _ctx.selectUser,
        ref: "afterSalePerson"
      }, null, 8, ["onSelectUser"]),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          (_ctx.saveConfigDisabled === false)
            ? (_openBlock(), _createBlock(_component_tree_node, {
                key: 0,
                treeData: _ctx.treeData,
                distanceIndex: 1,
                point: _ctx.point,
                onAddMenuById: _ctx.addMenuById,
                onAddPerssionById: _ctx.addPerssionById,
                onToEdit: _ctx.toEdit,
                onToDelete: _ctx.toDelete
              }, null, 8, ["treeData", "point", "onAddMenuById", "onAddPerssionById", "onToEdit", "onToDelete"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_space, { class: "authority-button-list" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.saveConfig,
                disabled: _ctx.saveConfigDisabled
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存配置")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.modalConfig.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalConfig.visible) = $event)),
      title: _ctx.modalConfig.title,
      onOk: _ctx.handleOk,
      okText: _ctx.modalConfig.okText,
      cancelText: _ctx.modalConfig.cancelText,
      centered: _ctx.modalConfig.centered,
      onCancel: _ctx.handleClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.formState,
          rules: _ctx.rules,
          "label-col": _ctx.labelCol,
          "wrapper-col": _ctx.wrapperCol,
          labelAlign: "left"
        }, {
          default: _withCtx(() => [
            (_ctx.modalConfig.title === '添加菜单')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "菜单名称",
                  name: "routeUrl"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.formState.identify,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.identify) = $event)),
                      allowClear: "",
                      options: _ctx.meneOptions,
                      style: {"width":"200px"}
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.modalConfig.title === '添加菜单')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 1,
                  label: "排序",
                  name: "sort"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.sort,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.sort) = $event)),
                      allowClear: "",
                      placeholder: "排序",
                      style: {"width":"200px"}
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.modalConfig.title === '修改菜单信息')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 2,
                  label: "菜单名称",
                  name: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.name,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.name) = $event)),
                      allowClear: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.modalConfig.title === '修改菜单信息')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 3,
                  label: "排序",
                  name: "sort"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.sort,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.sort) = $event)),
                      allowClear: "",
                      placeholder: "排序",
                      style: {"width":"200px"}
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.modalConfig.title === '权限配置')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 4,
                  label: "选择权限",
                  name: "permissions"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.permissionButton,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.permissionButton) = $event)),
                      mode: "multiple",
                      placeholder: "请选择权限",
                      style: {"width":"260px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: "look" }, {
                          default: _withCtx(() => [
                            _createTextVNode("查看")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "add" }, {
                          default: _withCtx(() => [
                            _createTextVNode("增加")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "edit" }, {
                          default: _withCtx(() => [
                            _createTextVNode("修改")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "delete" }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules", "label-col", "wrapper-col"])
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk", "okText", "cancelText", "centered", "onCancel"]),
    _createVNode(_component_filter_menu, { ref: "filterMenuRef" }, null, 512)
  ], 64))
}